import React, { useMemo } from 'react'
import * as classes from './Thanks.module.scss'
import cn from 'classnames'
import { deleteHtmlTag } from '../../../../../utils/deleteHtmlTag'

function Thanks({ open, thanksTitle, thanksText, lang }) {
    const title = useMemo(() => deleteHtmlTag(thanksTitle, 'all'), [])
    const text = useMemo(() => deleteHtmlTag(thanksText, 'all'), [])

    return (
        <div className={cn(classes.Wrapper, { [classes.Open]: open })}>
            {title ? (
                <span
                    className={classes.Title}
                    dangerouslySetInnerHTML={{__html: title}}
                    data-lang={lang}
                />
            ) : null}

            {text ? (
                <p
                    className={classes.Text}
                    dangerouslySetInnerHTML={{__html: text}}
                />
            ) : null}
        </div>
    )
}

export default Thanks
